import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import { FaTrash } from "react-icons/fa6";

export default function Centres() {
  const { centres } = useOutletContext();

  document.title = "Centres";

  return (
    <div className="overview-class admin-overview-class">
      <h1 className="heading1">Centres</h1>
      <div>
        {centres.map((centre) => (
          <div key={centre}>
            <h1
              className="heading3"
              style={{ textAlign: "left", width: "calc(100% - 80px)" }}
            >
              {centre}
            </h1>
            <span>
              <Link to={`/admin/overview/centres/${centre}`}>
                <FaTrash />
              </Link>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
